module.exports = __webpack_public_path__ + "img/add-person.c9398c8e.svg";